/**
 * Check if error is valid string to prevent not renderable widgets when `name` is not set in widget configuration.
 * @param error formik error message
 * @returns string | undefined
 */
export function getFormikErrorMessage(error: string | undefined): string | undefined {
  return error && typeof error === 'string' ? error : undefined;
}
